import { NavLink, useRouteMatch } from "react-router-dom";
import "./StudentItem.scss";
import { images } from "../../constants";
import { useDispatch } from "react-redux";
import {
  setStudentToDeleting,
  setStudentToUpdating,
} from "../../actions/student";
import { openModal } from "../../actions/ui";

const StudentItem = ({ student }) => {
  const dispatch = useDispatch();
  const { name, lastname, status } = student;
  const { url } = useRouteMatch(); // "/creator/students"

  const handleStudentEdit = (student) => {
    dispatch(setStudentToUpdating(student));

    dispatch(openModal());
  };

  const handleStudentDelete = (studentId) => {
    dispatch(setStudentToDeleting(studentId));
    dispatch(openModal());
  };

  return (
    <div className="student-item">
      <div className="student-item__wrapper">

        <div className="student-item__heanding">
          <div className="student-item__heading--img">
            <img src={images.IconProfileR} alt="" />
          </div>

          <div className="student-item__heading--content">
            <div className="student-item__heading--name">
              <NavLink to={`${url}/section-student/profile/${student._id}`}>
                <h3 className="title-gray-bold-16 set-pointer">{name}</h3>
                <h3 className="paragraph-gray-reg-16  set-pointer">
                  {lastname}
                </h3>
              </NavLink>
            </div>
            <div className="student-item-status">
              <p
                className={`student-staus paragraph-bold-14 ${
                  status === "Onshore" ? "isOnShore" : "isOffShore"
                } `}
              >
                {status}
              </p>
            </div>
          </div>
        </div>

        <div className="student-icons">
          <button
            className="student-icons__edit"
            onClick={() => handleStudentEdit(student)}
          >
            <img src={images.IconEdit} alt="icon to edit a student" />
          </button>

          <button
            className="student-icons__remove"
            onClick={() => handleStudentDelete(student._id)}
          >
            <img src={images.IconDelete} alt="icon to remove a student" />
          </button>
        </div>
        
      </div>
    </div>
  );
};

export default StudentItem;
